import wujiFetch from '@utils/wujiFetch';
const getQuota = async (projectId, envId) => await wujiFetch('/api/xy/ai/redis/usage/quota', { query: { projectId, envId } });
const listKeys = async (projectId, envId, prefix) => await wujiFetch('/api/xy/ai/redis/usage/keys', { query: { projectId, envId, prefix } });
const inspectKey = async (projectId, envId, key) => await wujiFetch('/api/xy/ai/redis/usage/key', { query: { projectId, envId, key } });
export default {
    getQuota,
    listKeys,
    inspectKey,
};
